import { render, staticRenderFns } from "./CreateInvitationDialog.vue?vue&type=template&id=bbde9a3e&scoped=true"
import script from "./CreateInvitationDialog.vue?vue&type=script&lang=js"
export * from "./CreateInvitationDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateInvitationDialog.vue?vue&type=style&index=0&id=bbde9a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbde9a3e",
  null
  
)

export default component.exports